// Primitive colour palette (2026). Six families, steps 50–950.
// Internal to the theme layer: semantic tokens in `colors.ts`
// they are intentionally NOT spread onto `theme.colors`.
export const amber = {
  50: '#FFFBF3',
  100: '#FFF3DA',
  200: '#FFE0A4',
  300: '#FCCB72',
  400: '#F3B844',
  500: '#E3A82B',
  600: '#AF7900',
  700: '#7F5500',
  800: '#593A00',
  900: '#3B2500',
  950: '#221300',
} as const

export const clay = {
  50: '#F8F7F5',
  100: '#ECEAE6',
  200: '#D9D7CF',
  300: '#C0BDB5',
  400: '#A5A299',
  500: '#86837B',
  600: '#66645D',
  700: '#4B4943',
  800: '#35342E',
  900: '#22211D',
  950: '#11100D',
} as const

export const indigo = {
  50: '#EBF6FC',
  100: '#D5EAF6',
  200: '#B4D8EC',
  300: '#87BEDB',
  400: '#5D9FC1',
  500: '#3C7A99',
  600: '#235F7C',
  700: '#104760',
  800: '#023348',
  900: '#002131',
  950: '#00101B',
} as const

export const rust = {
  50: '#FFF4F0',
  100: '#FFE2D5',
  200: '#FFC5AC',
  300: '#FDA484',
  400: '#EE7F56',
  500: '#CB6037',
  600: '#A44117',
  700: '#7E2900',
  800: '#601700',
  900: '#420900',
  950: '#270100',
} as const

export const fern = {
  50: '#EDFAF2',
  100: '#D3F1DF',
  200: '#ACE4C3',
  300: '#91CAA9',
  400: '#76AD8D',
  500: '#588B6E',
  600: '#3E6952',
  700: '#294D39',
  800: '#1A3828',
  900: '#0D2519',
  950: '#03130A',
} as const

export const moss = {
  50: '#F2F9EC',
  100: '#E0F0CE',
  200: '#C8DFAE',
  300: '#ADC592',
  400: '#91A876',
  500: '#718658',
  600: '#55683D',
  700: '#3D4D28',
  800: '#2A3718',
  900: '#1A240C',
  950: '#0B1203',
} as const
